<div class="detailed_wrapper">
  <div class="col-12">
    <div class="m-2">
      <em
        >Please check your official Rightworks invoice for the most accurate billing information, including sales
        tax.</em
      ><br />
      @if (isLoading) {
        <app-loader text="Loading..." inline="true"></app-loader>
      } @else {
        <wj-flex-grid
          [allowDragging]="'None'" 
          [selectionMode]="'None'" 
          [allowResizing]="'None'" 
          [headersVisibility]="'Column'"
          [itemsSource]="collectionView" 
          [isReadOnly]="true" 
          width="100%" 
          [autoGenerateColumns]="false"
          [sortOrder]="'DescAsc'">
          <wj-flex-grid-column width=".5*" header="Report Date" binding="ReportDate" sortIndex="0">
            <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
              {{ item.ReportDate | date: 'MM/d/yyyy' }}
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column width=".5*" header="Download">
            <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
              <a href="javascript:void(0)" class="download-link" (click)="getDetailedBillingReport(item.ReportID, item.FileDate)"><i class="fa fa-file linkButton"></i>Detailed Report</a>
            </ng-template>
          </wj-flex-grid-column>
        </wj-flex-grid>
      }
    </div>
  </div>
</div>
